module.exports = __webpack_public_path__ + "img/avatar6.8a2aa922.png";